import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconLockedConstrained = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M12 2.25C8.82436 2.25 6.25 4.82436 6.25 8V10C6.25 10.4142 6.58579 10.75 7 10.75C7.41421 10.75 7.75 10.4142 7.75 10V8C7.75 5.65279 9.65279 3.75 12 3.75C14.3472 3.75 16.25 5.65279 16.25 8V10C16.25 10.4142 16.5858 10.75 17 10.75C17.4142 10.75 17.75 10.4142 17.75 10V8C17.75 4.82436 15.1756 2.25 12 2.25Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.75 14C7.75 13.5858 7.41421 13.25 7 13.25C6.58579 13.25 6.25 13.5858 6.25 14V16C6.25 19.1756 8.82436 21.75 12 21.75C15.1756 21.75 17.75 19.1756 17.75 16V14C17.75 13.5858 17.4142 13.25 17 13.25C16.5858 13.25 16.25 13.5858 16.25 14V16C16.25 18.3472 14.3472 20.25 12 20.25C9.65279 20.25 7.75 18.3472 7.75 16V14Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.75 8C12.75 7.58579 12.4142 7.25 12 7.25C11.5858 7.25 11.25 7.58579 11.25 8V16C11.25 16.4142 11.5858 16.75 12 16.75C12.4142 16.75 12.75 16.4142 12.75 16V8Z",
			fill: "currentColor"
		})
	]
});
export { SvgIconLockedConstrained as ReactComponent };
